<template>
	<div class="i-select i-input">
		<span v-if="label" class="label">{{ label }}</span>
		<div
			class="select"
			tabindex="-1"
			:class="{show: isshow, disabledClass: !enable}"
			@focus="enable ? onfocus() : ''"
			@blur="enable ? onblur() : ''"
			@click="enable ? changeShow() : ''"
			@change="onChange"
		>
			{{ beChooseDFile ? beChooseDFile.label : nowitem.label }}
			<div class="option" v-show="isshow">
				<div
					v-for="(item, index) in options"
					:value="item.value"
					:selected="item.value == value"
					:key="index"
					@click="onChange()"
					@mouseenter="beingChoose(index)"
					:class="{beChoosed: nowrow == index}"
				>
					{{ item.label }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ISelect",
	props: {
		opts: Array,
		valueArray: Array,
		enable: Boolean,
		value: {},
		all: Boolean, // 是否可以选择全部
		label: {type: String, default: ""},
		str: String,
	},
	data() {
		return {
			ischange: false,
			isshow: false,
			nowrow: 0,
			beChooseDFile: {},
		};
	},
	computed: {
		options() {
			var ss = [];
			if (this.all)
				ss.push({value: null, label: typeof this.all === "string" ? this.all : this.$t("whole")});
			if (this.opts) {
				for (let i = 0; i < this.opts.length; i++) {
					let x = this.opts[i];
					let b = this.valueArray[i];
					if (this.value == b) {
						var that = this;
						that.nowrow = i;
						that.beChooseDFile = {value: b, label: x};
					}
					ss.push({value: b, label: x});
				}
			}
			return ss;
		},
		nowitem() {
			return this.options[this.nowrow];
		},
	},
	watch: {
		isshow(newval) {
			if (newval == false) this.nowrow = 0;
		},
	},
	methods: {
		onChange() {
			this.beChooseDFile = this.nowitem;
			let value = this.beChooseDFile.value;
			console.log("value", value);
			this.ischange = true;
			this.$emit("input", value, this.str);
			this.$emit("blur", true);
		},
		onfocus() {
			console.log("focus");
			// this.isshow = true;
			this.$emit("focus", true);
		},
		onblur() {
			console.log("blur");
			if (this.ischange) {
				this.ischange = false;
				return;
			}
			this.isshow = false;
			this.$emit("blur", true);
		},
		changeShow() {
			this.isshow = !this.isshow;
		},
		beingChoose(i) {
			this.nowrow = i;
		},
	},
	mounted() {},
	components: {},
};
</script>
<style lang="less">
@import "../styles/define.less";
.i-select {
	position: relative;
	display: inline-block;
	font-size: 0.9rem;
	+ .i-select,
	+ .i-input {
		margin-top: 0.7rem;
	}
	> .select {
		cursor: pointer;
		position: relative;
		box-sizing: border-box;
		outline: none;
		font-size: 12rem;
		font-family: Arial;
		font-weight: 400;
		color: #768ebe;
		width: 76rem;
		height: 20rem;
		line-height: 20rem;
		padding-right: 20rem;
		border: 1px solid #d3d3d3;
		opacity: 1;
		margin-right: 0 !important;
		border-radius: 2rem;
		// text-align: center;
		// padding-left: 10rem;
		text-align: center;
		appearance: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		&:disabled {
			color: rgba(211, 211, 211, 1) !important;
			cursor: auto;
		}
		&::after {
			content: "";
			width: 20rem;
			height: 20rem;
			box-sizing: border-box;
			background-image: url("../mycomponents/img/main-fn-body-secend/ico_jiantou_xia@2x.png");
			background-size: 8px 6rem;
			background-repeat: no-repeat;
			background-position: center center;
			/*通过定位将图标放在合适的位置*/
			position: absolute;
			right: 0;
			top: 0;
			/*给自定义的图标实现点击下来功能*/
			pointer-events: none;
			border-left: 1px solid #dce0e8;
		}
		.option {
			position: absolute;
			left: 0;
			bottom: 20rem;
			width: 76rem;
			box-shadow: 0px 4px 6px rgba(27, 33, 46, 0.08);
			div {
				width: inherit;
				height: 23rem;
				background-color: rgb(255, 255, 255);
				border-top: 1px solid #f4f4f4;
				line-height: 23rem;
				box-sizing: border-box;
				text-align: center;
			}
		}
		.beChoosed {
			background-color: #eff2f5 !important;
		}
	}
	.disabledClass {
		color: #dfdfdf !important;
	}
	> .label {
		color: #999;
		display: inline-block;
		margin-right: 0.5rem;
	}
	> .disabled {
		cursor: not-allowed;
		> span {
			opacity: 0.5;
		}
	}
	> label {
		> span {
			font-size: 0.8em;
		}
		&.active {
			> span {
				color: @blue;
			}
		}
	}
}
.show {
	&::after {
		background-image: url("../mycomponents/img/main-fn-body-secend/ico_jiantou_shang@2x.png") !important;
	}
}
</style>
